
import { useState,React } from 'react';
import { useNavigate} from 'react-router-dom';
import { Link } from "react-router-dom";

export default function AdminRegister() {

    const navigate = useNavigate();
    let roleArray=[
      {role:"Select Role"},
      {role:"Super Admin"},
      {role:"Admin"},
      {role:"Lab Incharge"},
      {role:"Student"},
    ]
    let [formData, setFormData] = useState
      (
        {
          user_id: Date.now(),
          firstName: "",
          lastName: "",
          email: "",
          phoneNo: "",
          role: "",
          password: ""
        }
      )
  
    const [error, setError] = useState
      (
        {
          user_id: "",
          firstName: "",
          lastName: "",
          email: "",
          phoneNo: "",
          role: "",
          password: ""
        }
      );
  
    function getFormData(e) {
      setFormData({
        ...formData,
        [e.target.name]: e.target.value
      });
      
      setError({
        ...error,
        [e.target.name]: ""
      })
    }
  
    function validateForm() {
      let error = {};
      let isValid = true;
  
      if (!formData.firstName) {
        error.firstName = "First name is required"
      }
  
      if (!formData.lastName) {
        error.lastName = "Last name is required"
      }
  
      if (!formData.email) {
        error.email = "Email is required";
        isValid = false;
      } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(formData.email)) {
        error.email = "Enter a valid email address";
        isValid = false;
      }
      // [6-9]\\d{9}
      if (!formData.phoneNo) {
        error.phoneNo = "Phone no is required"
      } else if (!/^[6789]\d{9}$/.test(formData.phoneNo)) {
        error.mobile = "Enter a valid mobile number";
        isValid = false;
      }
  
      if (!formData.role) {
        error.role = "Role is required"
      }
  
      if (!formData.password) {
        error.password = "Password is required";
        isValid = false;
      } else if (formData.password.length < 8) {
        error.password = "Password must be at least 8 characters";
        isValid = false;
      }
      setError(error);
      return isValid;
    }
  
    function onSubmitData(e) {
      e.preventDefault();
      if (!validateForm()) return;
      const newFormData = { ...formData, [e.target.name]: e.target.value };
      const existingData = JSON.parse(localStorage.getItem("userDetails")) || [];
      const updatedData = [...existingData, newFormData];
      localStorage.setItem("userDetails", JSON.stringify(updatedData));
      let loginUrl=`/auth/login/id:${formData.user_id}`;
      //console.log(loginUrl);
       navigate(loginUrl);
      // console.log(loginUrl);
       
       setFormData({
        firstName: "",
        lastName: "",
        email: "",
        phoneNo: "",
        role: "",
        password: ""
      })
    }
  
    return (
      <>
        <div className="container mx-auto px-4 h-full">
          <div className="flex content-center items-center justify-center h-full">
            <div className="w-full lg:w-6/12 px-4">
              <div className="relative flex flex-col min-w-0 break-words w-full mb-6 shadow-lg rounded-lg bg-blueGray-200 border-0">
                <div className="flex-auto px-4 lg:px-10 py-10 pt-0">
                  <div className="text-blueGray-900 text-center mb-3 font-bold">
                    <small>Sign up</small>
                  </div>
                  <form onSubmit={onSubmitData}>
                    <div className="relative w-full mb-3">
                      <label className="block  text-blueGray-600 text-xs font-bold mb-2" htmlFor="grid-password">First Name</label>
                      <input type="text"
                        name="firstName"
                        value={formData.firstName}
                        onChange={getFormData}
                        className="border-0 px-3 py-3 placeholder-blueGray-300 text-blueGray-600 bg-white rounded text-sm shadow focus:outline-none focus:ring w-full ease-linear transition-all duration-150" placeholder="First Name" />
                      {error.firstName && <p className="text-red-500 text-xs mt-1">{error.firstName}</p>}
                    </div>
  
                    <div className="relative w-full mb-3">
                      <label className="block  text-blueGray-600 text-xs font-bold mb-2" htmlFor="grid-password">Last Name</label>
                      <input type="text"
                        name="lastName"
                        value={formData.lastName}
                        onChange={getFormData}
                        className="border-0 px-3 py-3 placeholder-blueGray-300 text-blueGray-600 bg-white rounded text-sm shadow focus:outline-none focus:ring w-full ease-linear transition-all duration-150" placeholder="Last Name" />
                      {error.lastName && <p className="text-red-500 text-xs mt-1">{error.lastName}</p>}
                    </div>
  
                    <div className="relative w-full mb-3">
                      <label className="block  text-blueGray-600 text-xs font-bold mb-2" htmlFor="grid-password" > Email </label>
                      <input type="email"
                        name="email"
                        value={formData.email}
                        onChange={getFormData}
                        className="border-0 px-3 py-3 placeholder-blueGray-300 text-blueGray-600 bg-white rounded text-sm shadow focus:outline-none focus:ring w-full ease-linear transition-all duration-150" placeholder="Email" />
                      {error.email && <p className="text-red-500 text-xs mt-1">{error.email}</p>}
                    </div>
  
                    <div className="relative w-full mb-3">
                      <label className="blocktext-blueGray-600 text-xs font-bold mb-2" htmlFor="grid-password">Phone No</label>
                      <input type="text" maxLength={10} minLength={10}
                        name="phoneNo"
                        value={formData.phoneNo}
                        onChange={getFormData}
                        className="border-0 px-3 py-3 placeholder-blueGray-300 text-blueGray-600 bg-white rounded text-sm shadow focus:outline-none focus:ring w-full ease-linear transition-all duration-150" placeholder="Phone No" />
                      {error.phoneNo && <p className="text-red-500 text-xs mt-1">{error.phoneNo}</p>}
                    </div>
  
                    <div className="relative w-full mb-3">
                      <label className="block text-blueGray-600 text-xs font-bold mb-2" htmlFor="role">
                        Role
                      </label>
                      <select
                        name="role"
                        value={formData.role}
                        onChange={getFormData}
                        className="border-0 px-3 py-3 text-blueGray-600 bg-white rounded text-sm shadow focus:outline-none focus:ring w-full ease-linear transition-all duration-150"
                      >
                       { roleArray.map((x)=>(
                          <option key={x.id} value={x.role}>{x.role}</option>
                        ))
                       }
                      </select>
                      {error.role && <p className="text-red-500 text-xs mt-1">{error.role}</p>}
                    </div>
  
  
                    <div className="relative w-full mb-3">
                      <label className="block  text-blueGray-600 text-xs font-bold mb-2" htmlFor="grid-password" >  Password  </label>
                      <input type="password"
                        name="password" minLength={8} maxLength={14}
                        value={formData.password}
                        onChange={getFormData}
                        className="border-0 px-3 py-3 placeholder-blueGray-300 text-blueGray-600 bg-white rounded text-sm shadow focus:outline-none focus:ring w-full ease-linear transition-all duration-150" placeholder="Password" />
                      {error.password && <p className="text-red-500 text-xs mt-1">{error.password}</p>}
                    </div>
  
                    <div className="text-center mt-6">
                      <button
                        className="bg-blueGray-800 text-white active:bg-blueGray-600 text-sm font-bold uppercase px-6 py-3 rounded shadow hover:shadow-lg outline-none focus:outline-none mr-1 mb-1 w-full ease-linear transition-all duration-150"
                        type="submit">
                        Create Account
                      </button>
                      <div className="mt-4 text-center">
                        <p className="text-blue-500">
                          Already a user?{" "}
                          <Link to="auth/login" className="font-semibold hover:underline">
                            Sign In
                          </Link>
                        </p>
                      </div>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </>
    );
  }
  